import { render, staticRenderFns } from "./TifLiquidacionesIndex.vue?vue&type=template&id=7dd7e780"
import script from "./TifLiquidacionesIndex.vue?vue&type=script&lang=js"
export * from "./TifLiquidacionesIndex.vue?vue&type=script&lang=js"
import style0 from "./TifLiquidacionesIndex.vue?vue&type=style&index=0&id=7dd7e780&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports